import { render } from "./Index.vue?vue&type=template&id=8389dfae&scoped=true"
const script = {}

import "./Index.vue?vue&type=style&index=0&id=8389dfae&scoped=true&lang=css"

import exportComponent from "D:\\project\\52haoma\\pc-52haoma\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8389dfae"]])

export default __exports__